import React, { useEffect, useContext, useState } from 'react';

import {
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';

import {
  useHistory,
  useParams,
  withRouter,
} from 'react-router-dom';

import PropTypes from 'prop-types';

import BreadCrumb from '../../fields/breadCrumb';
import CustomSnackbar from '../../feedback/customSnackbar';
import Footer from '../../fields/footer';
import Header from '../../fields/header';
import MenuDrawer from '../../fields/menuDrawer';
import ProgramDetails from './programDetails';
import SpinnerLoading from '../../feedback/spinnerLoading';

import { getProgramInfo } from '../../../utils/comms';

import translations from '../../../languages/i18n';

import { sectionTitle } from '../../../styles/formElementsStyles';

import generalStyles from '../../../styles/generalStyles';

// NOTA: Per poder emprar el react-router-dom i enllaçar pàgines s'ha de convertir el component en una funció i exportar-lo embolicat per withRouter
// En cas de que el component sigui un fill directe de Route no fa falta fer-ho
// Explicat al punt 2.1. Using withRouter de https://dev.to/projectescape/programmatic-navigation-in-react-3p1l

import { SessionContext } from '../../../utils/context';

function EditProgramInfo({ lang, handleChangeLang, type }) {
  const sessionContext = useContext(SessionContext);

  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackType, setFeedbackType] = useState('');
  const [ready, setReady] = useState(false);
  const [programData, setProgramData] = useState({});
  const [showDrawer, setShowDrawer] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const classes = generalStyles();
  const sectionTitleStyle = sectionTitle();

  const history = useHistory();
  const { idProgram } = useParams();

  useEffect(() => {
    const getProgramInfoFromServer = async () => {
      setShowLoading(true);
      const response = await getProgramInfo(idProgram, sessionContext.userToken);
      setShowLoading(false);
      if (response.status === 200) { // Tenim llistat
        setProgramData(response.data.program);
        setReady(true);
      } else if (response === 400) { // Error amb les dades
        console.log('Error 400');
      } else { // Login KO. Altres errors
        console.log(response);
      }
    };
    if (type === 'new') {
      setReady(true);
    } else {
      getProgramInfoFromServer();
    }
  }, []); // [] Indica que l'useEffect només s'executa una vegada, no a cada render

  const gotoScreen = (screen) => {
    history.push(`/${sessionContext.role.toLowerCase()}/${screen}`);
  };

  const manageFeedback = (fbType, fbMessage) => {
    setFeedbackMessage(translations[`_${fbType}${fbMessage}`]);
    setFeedbackType(fbType);
    setShowFeedback(true);
  };

  const showMenuDrawer = (show) => {
    setShowDrawer(show);
  };

  return (
    <div className={classes.content}>
      <SpinnerLoading show={showLoading} />
      <Header type={sessionContext.role.toLowerCase()} lang={lang} handleChangeLang={handleChangeLang} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <MenuDrawer type={sessionContext.role.toLowerCase()} showDrawer={showDrawer} handleShowDrawer={(show) => showMenuDrawer(show)} handleGotoScreen={(screen) => gotoScreen(screen)} />
      <CustomSnackbar show={showFeedback} handleCloseFeedback={(show) => setShowFeedback(show)} type={feedbackType} message={(showFeedback && feedbackMessage) || ''} />
      <div className={classes.body}>
        <Grid container spacing={2} justify='space-around'>
          {/* ----------------------- Fila 0 ----------------------- */}
          <Grid item xs={12}>
            <BreadCrumb role={sessionContext.role.toLowerCase()} home='listPrograms' lang={lang} />
          </Grid>
          {/* ----------------------- Fila 1 ----------------------- */}
          <Grid item xs={11} className={sectionTitleStyle.root}>
            <Grid container justify='flex-start'>
              <Grid item>
                {sessionContext.role === 'Admin' ? (
                  <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{type === 'new' ? translations['_newProgramData'] : translations['_editProgramData']}</Typography>
                ) : (
                  <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_viewProgramData']}</Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila 2 ----------------------- */}
          <Grid item xs={11}>
            <Grid container component={Paper} justify='flex-start' alignItems='flex-end' spacing={4}>
              {ready && <ProgramDetails type={type} detailsData={programData} handleFeedback={(fbType, fbMessage) => manageFeedback(fbType, fbMessage)} />}
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(EditProgramInfo);

// Indica i controla els props que se han de passar al component
EditProgramInfo.propTypes = {
  handleChangeLang: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
